export const INTERNAL_VARIABLES = [
  'air_pressure_at_mean_sea_level',
  'air_temperature_at_height_level_2m',
  'dew_point_temperature_at_height_level_2m',
  'cloud_area_fraction_at_entire_atmosphere_high_type',
  'cloud_area_fraction_at_entire_atmosphere_medium_type',
  'cloud_area_fraction_at_entire_atmosphere_low_type',
  'geopotential_at_pressure_level_50000Pa',
  'precipitation_amount_sum_1h',
  'relative_humidity_at_height_level_2m',
  'surface_direct_downwelling_shortwave_flux_sum_1h',
  'surface_downwelling_shortwave_flux_sum_1h',
  'wind_direction_at_height_level_100m',
  'wind_direction_at_height_level_10m',
  'wind_speed_at_height_level_100m',
  'wind_speed_at_height_level_10m',
] as const;

export type InternalVariable = (typeof INTERNAL_VARIABLES)[number];

export const STATS = ['mean', 'std', 'q5', 'q25', 'q75', 'q95'] as const;

export type InternalStat = (typeof STATS)[number];
